import { ActionType, createAction } from 'typesafe-actions';

export const setDefaultHeaderState = createAction('SET_DEFAULT_HEADER_STATE', action => {
    return () => action();
});

export type HeaderActionTypes = ActionType<typeof setDefaultHeaderState>;
